// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditProfileBox_wrapper__3j1eh","text":"EditProfileBox_text__2Yyq0","heb":"EditProfileBox_heb__rjcQn"};